module.exports = __webpack_public_path__ + "static/media/BoyNeonXRosa_GraceBeck-16.01ba4bf0.JPG";